import React from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import PrivateRoute from "components/common/PrivateRoute";
import MerchandiserInvoicingList from "components/menu/invoicing/merchandiser/list";
import CustomerInvoicingList from "components/menu/invoicing/customer/list";
import AccountingExportList from "../menu/invoicing/accountingExport/list";
import MissingChargesList from "../menu/invoicing/missingCharges/list";

const InvoicingRouter = props => (
    <div className="px-5">
        <Switch>
            <PrivateRoute
                exact
                path={`${props.match.url}/merchandiser`}
                component={MerchandiserInvoicingList}
            />
            <PrivateRoute
                exact
                path={`${props.match.url}/customer`}
                component={CustomerInvoicingList}
            />
            <PrivateRoute
                exact
                path={`${props.match.url}/accountingExport`}
                component={AccountingExportList}
            />
            <PrivateRoute
                exact
                path={`${props.match.url}/missingCharges`}
                component={MissingChargesList}
            />
        </Switch>
    </div>
);

export default connect()(InvoicingRouter);
